import {computed} from 'vue';
import {until} from '@vueuse/core';
import {defineStore} from 'pinia';
import {usePermissionListQuery} from '@/api/queries/queries/usePermissionListQuery';
import type {PermissionName} from '@/api/models/permissions/permissionName';

export const usePermissionStore = defineStore('permissions', () => {
    const {permissionList, isLoading} = usePermissionListQuery();

    const heldPermissions = computed(() => new Set(permissionList.value?.permissions ?? []));

    // TODO RBAC: goes with the legacy gates. A missing list counts as not enforced, as the backend steps aside on a failing catalogue.
    const isCatalogueEnforced = computed(() => permissionList.value?.catalogueEnforced ?? false);

    // Held somewhere, never on a particular object. A screen about one object reads a flag on its response.
    function can(permission: PermissionName): boolean {
        return heldPermissions.value.has(permission);
    }

    // TODO RBAC: goes with the legacy gates
    function holdsDuringRollout(permission: PermissionName): boolean {
        return !isCatalogueEnforced.value || can(permission);
    }

    // TODO RBAC: goes with the legacy gates, the call site then asks can(). ANDed like the backend, an OR shows screens whose actions answer 403.
    function canDuringRollout(legacyGranted: boolean, permission: PermissionName): boolean {
        return legacyGranted && holdsDuringRollout(permission);
    }

    async function isReady(): Promise<void> {
        await until(isLoading).toBe(false);
    }

    return {isLoading, isCatalogueEnforced, can, holdsDuringRollout, canDuringRollout, isReady};
});
